const mapAdvancedBlock = block => {
  return {
    block_uid: block.block_uid,
    visible_from: block.visible_from,
    visible_until: block.visible_until,
    visibility_criterion_ids: block.visibility_criterion_ids,
  }
}

export const transformResponseAdvancedBlocks = response => response.results.map(mapAdvancedBlock)

export const transformRequestEditAdvancedBlock = ({ storeId, blockUid, payload }) => {
  return {
    storeId,
    blockUid,
    config: {
      visible_from: payload.visible_from,
      visible_until: payload.visible_until,
      visibility_criterion_ids: payload.visibility_criterion_ids,
    },
  }
}
